import { useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  // getAppAction,
  getLoginInfo,
  getSearchInfo,
  setToken,
} from '../../../shared/utils/storage';
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import { createNotification } from '../../../shared/components/Popup';
import { error } from "jquery";
import Box from "@mui/material/Box";
import Modal from "react-bootstrap/Modal";
const DecissionComponent = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  //const newData = location.state
  const newData = getSearchInfo();
  const stageID = newData?.data?.ApplicationStatus[0]?.StageID;

  const applicationID = newData?.data?.ApplicationStatus[0]?.ApplicationID;

  const [recommendation, setRecomendation] = useState([]);
  const [isReject, setIsReject] = useState(false);

  const [recommendationID, setRecommendationID] = useState();
  const [comment, setcomment] = useState();
  const [userHistory, setUserHistory] = useState([]);

  // const [RoutbackCheck, setRoutbackCheck] = useState("1");
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const styles = {
    h4: {
      color: "#850505",
      // textTransform: 'uppercase',
    },
  };
  useEffect(() => {
    getRcommendation();
  }, []);

  const closeReject = () => {
    setIsReject(false);
  };
  const getRcommendation = async () => {
    const payload = {
      ApplicationId: null,
      UserName: getLoginInfo()?.user?.Username,
      Station: getLoginInfo()?.user?.StationID,
      ResourceParam: stageID,
      ResourceParam2: "null",
      ResourceType: "Recommend",
    };

    const result = await handleApplicationManagement(payload, "lookup");
    if (result?.code == 1) {
      setRecomendation(result.data);
      getUserHistory();
    } else {
      const info = { type: "error", message: result?.message };
      createNotification(info)();
    }
  };
  const ActionDumy = [
    {
      AppId: "",
      Date: "",
      Message: "",
      Recommendation: "",
      Stage: "",
      Station: "",
      Station: "",
      Username: "",
    },
  ];

  // let ViewAction = ActionDumy;
  // const pima = getAppAction();
  // if (pima != null) {
  //   ViewAction = getAppAction();
  // }

  const getUserHistory = async () => {
    const payload = {
      ApplicationId: applicationID,
      Action: "History",
      StageId: stageID,
      Station: getLoginInfo()?.user?.StationID,
      UserName: getLoginInfo()?.user?.Username,
    };

    const result = await handleApplicationManagement(
      payload,
      "application_management",
    );
    if (result?.code == "1") {
      setUserHistory(result?.data);
    } else {
      // const info = { type: "error", message: result?.message };
      // createNotification(info)();
    }
  };

  const decisionHandler = (e) => {
    setRecommendationID(e.target.value);
    let decisionID = e.target.value;
    if (decisionID == "5") {
      setIsReject(true);
    }
  };

  const Recommend = async (e) => {
    e.preventDefault();
    // const res = Recommendation.split('/');
    const payload = {
      UserName: getLoginInfo()?.user?.Username,
      Station: getLoginInfo()?.user?.StationID,
      RecommendationId: recommendationID,
      StageId: stageID,
      Message: comment,
      CommentTypeId: "",
      SystemID: "UHM002",
      ApplicationId: applicationID,
    };

    const result = await handleApplicationManagement(payload, "decision");
    if (result?.code == 1) {
      setRecomendation(result.data);
      setToken(result?.token);

      routsManagement();
      const info = { type: "success", message: result?.message };
      createNotification(info)();
    } else {
      const info = { type: "error", message: result?.message };
      createNotification(info)();
    }
  };

  const routsManagement = () => {
    switch (stageID) {
      case 510:
        navigate("/assessment");
        break;
      case 520:
        navigate("/approval");
        break;
      case 530:
        navigate("/po1");
        break;
    }
  };

  return (
    <>
      <div className="">
        <table id="viewTable">
          <tr>
            <th colspan="5">
              <h4>
                <b>Recommendations </b>
              </h4>
            </th>
          </tr>
        </table>
        <center>
          <div className="selectBox">
            <div className="col-md-7">
              <br />
              <div style={{ width: "14rem" }}>
                <select
                  id="recommendationID"
                  className="form-control"
                  name="recommendationID"
                  value={recommendationID}
                  onChange={(e) => decisionHandler(e)}
                  required
                >
                  <option value="">select</option>
                  {Array.isArray(recommendation) &&
                  recommendation.length > 0 ? (
                    recommendation.map((item) => (
                      <option key={item.ResourceID} value={item.ResourceID}>
                        {item.ResourceName}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      Hakuna hatua
                    </option>
                  )}
                </select>
              </div>
              {/*--------end --------*/}
              <br />
              <div className="form-group">
                <label htmlFor="exampleFormControlTextarea1">
                  <h5>
                    <i>officer's comments</i>
                  </h5>
                </label>
                <textarea
                  style={{ color: "#850505", fontSize: "1rem" }}
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="1"
                  value={comment}
                  onChange={(e) => {
                    setcomment(e.target.value);
                  }}
                  aria-required="true"
                />
              </div>
              {recommendationID != "5" && (
                <button
                  className="btn btn-info"
                  onClick={Recommend}
                  name="Action"
                  style={{ textAlign: "center" }}
                >
                  <b style={{ fontSize: "13px" }}>Recommend</b>
                </button>
              )}
              {recommendationID == "5" && (
                <button
                  className="btn btn-danger"
                  onClick={Recommend}
                  name="Action"
                  style={{ textAlign: "center" }}
                >
                  <b style={{ fontSize: "13px" }}>Reject</b>
                </button>
              )}
            </div>
          </div>
        </center>
        <table id="viewTable">
          <tr>
            <th colspan="5">
              <h4>
                <b>Action History</b>
              </h4>
            </th>
          </tr>
          <tr>
            <td style={{ width: "24%" }}>Action Date</td>
            <td style={{ width: "15%" }}>Action By</td>
            <td style={{ width: "10%" }}>Stage</td>
            <td style={{ width: "20%" }}>Action</td>
            <td style={{ width: "*" }}>Remark / Comments</td>
          </tr>
          {userHistory.map((obj) => (
            <tr>
              <td>
                <h4 style={styles.h4}>{obj?.DateUpdated}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj?.Username}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj?.StageName}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj?.RecommendationName}</h4>
              </td>
              <td>
                <h4 style={styles.h4}>{obj.Message}</h4>
              </td>
            </tr>
          ))}
        </table>

        <Modal show={isReject} onHide={closeReject} size="sm" centered>
          <form>
            <Modal.Header closeButton>
              <Modal.Title>Rejection</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Box
                display="flex"
                justifyContent="center"
                sx={{ "& > :not(style)": { m: 1 } }}
              >
                <div></div>
                <div className="col-md-12 error-text">
                  <p>Do you really want to reject it?</p>
                </div>
                <div></div>
              </Box>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-sm btn-primary error-text"
                onClick={Recommend}
              >
                Yes, Reject
              </button>
              <button
                type="button"
                className="btn  btn-sm btn-primary error-text"
                onClick={closeReject}
              >
                No, Change
              </button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </>
  );
};

export default DecissionComponent;
